import { ButtonIcons, Icons } from '..';
import accountFilled from './icons/account-filled.svg';
import accountOutlined from './icons/account-outlined.svg';
import add from './icons/add.svg';
import alert from './icons/alert.svg';
import arrowDown from './icons/arrow-down.svg';
import arrowUp from './icons/arrow-up.svg';
import breakdown from './icons/breakdown.svg';
import calendarOutlined from './icons/calendar-outline.svg';
import calendar from './icons/calendar.svg';
import carFilled from './icons/car-filled.svg';
import carOutlined from './icons/car-outlined.svg';
import chevron from './icons/chevron.svg';
import close from './icons/close.svg';
import cross from './icons/cross.svg';
import downloadDocumentFilled from './icons/download-document-filled.svg';
import downloadDocumentOutlined from './icons/download-document-outlined.svg';
import downloadGeneric from './icons/download-generic.svg';
import edit from './icons/edit.svg';
import error from './icons/error.svg';
import gbNumberPlate from './icons/gb-numberplate.svg';
import homeFilled from './icons/home-filled.svg';
import homeOutlined from './icons/home-outlined.svg';
import included from './icons/included.svg';
import menu from './icons/menu.svg';
import minus from './icons/minus.svg';
import newTab from './icons/new-tab.svg';
import petFilled from './icons/pet-filled.svg';
import petOutlined from './icons/pet-outlined.svg';
import plus from './icons/plus.svg';
import print from './icons/print.svg';
import refresh from './icons/refresh.svg';
import remove from './icons/remove.svg';
import save from './icons/save.svg';
import speechBubble from './icons/speech bubble.svg';
import swipeLeft from './icons/swipe-left.svg';
import swipeRight from './icons/swipe-right.svg';
import telephoneFilled from './icons/telephone-filled.svg';
import telephoneOutlined from './icons/telephone-outlined.svg';
import telephonePlain from './icons/telephone-plain.svg';
import tick from './icons/tick.svg';
import warning from './icons/warning.svg';

export const icons: Icons = {
  account: {
    default: accountFilled,
    variant: accountOutlined,
  },
  alert: {
    default: alert,
  },
  'arrow-down': {
    default: arrowDown,
  },
  'arrow-up': {
    default: arrowUp,
  },
  breakdown: {
    default: breakdown,
  },
  chevron: {
    default: chevron,
  },
  'download-document': {
    default: downloadDocumentFilled,
    variant: downloadDocumentOutlined,
  },
  'download-generic': {
    default: downloadGeneric,
  },
  included: {
    default: included,
  },
  tick: {
    default: tick,
  },
  'not-included': {
    default: cross,
  },
  cross: {
    default: cross,
  },
  'telephone-plain': {
    default: telephonePlain,
  },
  telephone: {
    default: telephoneFilled,
    variant: telephoneOutlined,
  },
  car: {
    default: carFilled,
    variant: carOutlined,
  },
  home: {
    default: homeFilled,
    variant: homeOutlined,
  },
  pet: {
    default: petFilled,
    variant: petOutlined,
  },
  refresh: {
    default: refresh,
  },
  menu: {
    default: menu,
  },
  'close-menu': {
    default: cross,
  },
  plus: {
    default: plus,
  },
  minus: {
    default: minus,
  },
  error: {
    default: error,
  },
  'swipe-left': {
    default: swipeLeft,
  },
  'swipe-right': {
    default: swipeRight,
  },
  add: {
    default: add,
  },
  remove: {
    default: remove,
  },
  'gb-numberplate': {
    default: gbNumberPlate,
  },
  close: {
    default: close,
  },
  save: {
    default: save,
  },
  'speech-bubble': {
    default: speechBubble,
  },
  print: {
    default: print,
  },
  warning: {
    default: warning,
  },
  edit: {
    default: edit,
  },
  'new-tab': {
    default: newTab,
  },
  calendar: {
    default: calendar,
    variant: calendarOutlined,
  },
};

export const buttonIcons: ButtonIcons = {
  cta: 'chevron',
  add: 'add',
  back: 'chevron',
  download: 'download-document',
  downloadGeneric: 'download-generic',
  edit: 'edit',
  ctaOpenInNewTab: 'new-tab',
  remove: 'remove',
};
